import { AssignTransferToTripFolderRequest } from '../../lib/types/models/trip-folder/trip-folder-input'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function updateTransferPlace(data: AssignTransferToTripFolderRequest) {
  const { tripFolderId, transferId, ...rest } = data

  return restApiClient
    .url(constructApiUrl(API.tripFolder.updateTransfer.url, { id: tripFolderId, transferId }))
    .patch(rest)
}
